"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var ConfigProvider_1 = require("../ConfigProvider");
var Tooltip_1 = tslib_1.__importDefault(require("../Tooltip"));
var utils_1 = require("../utils");
var Inner_1 = tslib_1.__importDefault(require("./Inner"));
function Popover(props) {
    var title = props.title, content = props.content, icon = props.icon, prefixCls = props.prefixCls, buttons = props.buttons, _a = props.defaultVisible, defaultVisible = _a === void 0 ? false : _a, onVisibleChange = props.onVisibleChange, rest = tslib_1.__rest(props, ["title", "content", "icon", "prefixCls", "buttons", "defaultVisible", "onVisibleChange"]);
    var _b = react_1.useState(defaultVisible), tooltipVisible = _b[0], setTooltipVisible = _b[1];
    var prefix = ConfigProvider_1.usePrefix('popover', prefixCls);
    var innerPrefix = utils_1.concat(prefix, 'inner');
    function onTooltipVisibleChange(value) {
        onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(value);
        setTooltipVisible(value);
    }
    return (react_1.default.createElement(Tooltip_1.default, tslib_1.__assign({ title: react_1.default.createElement(Inner_1.default, { title: title, icon: icon, content: content, prefix: innerPrefix, buttons: buttons, close: function () { return setTooltipVisible(false); } }), prefixCls: prefix, visible: tooltipVisible, onVisibleChange: onTooltipVisibleChange }, rest)));
}
exports.default = Popover;
//# sourceMappingURL=index.js.map